<script>
import { mapState } from "vuex";

export default {
	name: "compPerkawinanDetail",
	data() {
		return {};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatPerkawinanItem: (state) => state.umatPerkawinan.item,
		}),
	},
};
</script>

<template>
	<table class="table table-striped table-hover text-left">
		<tbody>
			<!-- <tr>
				<td>Nama Suami</td>
				<td>:</td>
				<td>{{ umatPerkawinanItem.nama_suami }}</td>
			</tr> -->
			<tr>
				<td>Nama Pasangan</td>
				<td>:</td>
				<td>{{ umatPerkawinanItem.nama_pasangan }}</td>
			</tr>

			<tr>
				<td>No. Buku LM</td>
				<td>:</td>
				<td>{{ umatPerkawinanItem.no_buku_lm }}</td>
			</tr>
			<tr>
				<td>No. LM</td>
				<td>:</td>
				<td>{{ umatPerkawinanItem.no_lm }}</td>
			</tr>
			<tr>
				<td>Tanggal Perkawinan</td>
				<td>:</td>
				<td>{{ umatPerkawinanItem.tgl_perkawinan_human }}</td>
			</tr>
			<tr>
				<td>Imam Peneguh</td>
				<td>:</td>
				<td>{{ umatPerkawinanItem.imam_peneguh }}</td>
			</tr>
			<tr>
				<td>Keuskupan LC</td>
				<td>:</td>
				<td>{{ umatPerkawinanItem.keuskupan_lm }}</td>
			</tr>
			<tr>
				<td>Paroki LC</td>
				<td>:</td>
				<td>{{ umatPerkawinanItem.paroki_lm }}</td>
			</tr>
			<tr>
				<td>Nama Saksi I</td>
				<td>:</td>
				<td>{{ umatPerkawinanItem.wali }}</td>
			</tr>
			<tr>
				<td>Nama Saksi II</td>
				<td>:</td>
				<td>{{ umatPerkawinanItem.wali2 }}</td>
			</tr>
		</tbody>
	</table>
</template>

